import { ChatEmpty } from "./chat-empty";
import { ChatFileAttachments } from "./chat-file-attachments";
import { ChatHeader } from "./chat-header";
import { ChatInput } from "./chat-input";
import { ChatLoading } from "./chat-loading";
import { ChatMessages } from "./chat-messages";
import { ChatModals } from "./chat-modals";
import { ChatRoot } from "./chat-root";

// Compound component pattern
const Chat = Object.assign(ChatRoot, {
  Header: ChatHeader,
  Messages: ChatMessages,
  Input: ChatInput,
  FileAttachments: ChatFileAttachments,
  Loading: ChatLoading,
  Empty: ChatEmpty,
  Modals: ChatModals,
});

// Export compound component
export { Chat };

// Export context hooks for advanced usage
export {
  ChatConfigContext,
  useChatConfigContext,
  useChatInputContext,
  useChatModalsRefContext,
  useChatScrollRefContext,
  useChatSuggestionsContext,
} from "./chat-context";

// Export types
export type {
  ChatConfigContextValue,
  ChatInputContextValue,
  ChatMessagesHandle,
  ChatModalsHandle,
  ChatModalsRefContextValue,
  ChatScrollRefContextValue,
  ChatSuggestionsContextValue,
} from "./contexts";
export type { MessageDraft } from "./hooks/use-chat-draft";

// Export individual components for flexibility
export { ChatHeader } from "./chat-header";
export { ChatMessages } from "./chat-messages";
export { ChatInput } from "./chat-input";
export { ChatFileAttachments } from "./chat-file-attachments";
export { ChatLoading, ChatLoadingSkeleton } from "./chat-loading";
export { ChatEmpty } from "./chat-empty";
export { ChatModals } from "./chat-modals";
export { ChatRoot } from "./chat-root";
